// extracted by mini-css-extract-plugin
export var callCard = "_mf-0";
export var callMessageButton = "_mf-1";
export var helpIcon = "_mf-3";
export var helpIconContainer = "_mf-4";
export var verticalDivider = "_mf-2";